module.exports = __webpack_public_path__ + "img/it.f43de766.png";